<template>
  <div
    v-if="modelData.isImageModalShown"
    class="cm-root">
    <div
      class="cm-backdrop"
      @click="onBackdrop" />
    <div
      class="cm-dialog"
      :class="{ 'is-wide': isBanner }"
      role="alertdialog"
      aria-modal="true"
      :aria-label="modelData.title || 'Confirmation'">
      <div
        v-if="isBanner"
        class="cm-banner">
        <span
          class="cm-icon is-warning"
          aria-hidden="true">
          <icon :name="modalIcon" />
        </span>
        <div class="cm-copy">
          <h2>{{ modelData.title }}</h2>
          <p>{{ modelData.message }}</p>
        </div>
      </div>
      <div
        v-else
        class="cm-body">
        <button
          type="button"
          class="cm-close"
          aria-label="Close"
          title="Close"
          @click="handleModalClose">
          <icon name="close-icon" />
        </button>

        <span
          v-if="modalIcon"
          class="cm-icon"
          :class="'is-' + modalKind"
          aria-hidden="true">
          <icon :name="modalIcon" />
        </span>

        <p class="cm-text">{{ modelData.message }}</p>

        <div
          v-if="modalButtons.length"
          class="cm-actions"
          :class="{ 'is-single': modalButtons.length === 1 }">
          <button
            v-for="(button, index) in modalButtons"
            :key="index"
            :class="button.variant === 'solid' ? 'is-solid' : 'is-outline'"
            :style="{ background: button.background, color: button.color }"
            type="button"
            class="cm-btn"
            @click="onButton(button)">
            {{ button.label }}
          </button>
        </div>
      </div>
      <div
        v-if="isBanner"
        class="cm-footer">
        <button
          v-for="(button, index) in modalButtons"
          :key="index"
          :class="button.variant === 'solid' ? 'is-solid' : 'is-outline'"
          :style="{ background: button.background, color: button.color }"
          type="button"
          class="cm-btn"
          @click="onButton(button)">
          {{ button.label }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';

export default {
  data() {
    return {
      isTabClicked:   false,
      selectedId:     '1',
      isGalleryShown: false,
      query:          '',
      isFocused:      false,
      isFocusedOut:   false,
      tempData:       '',
      modelData:      {
        isImageModalShown: false,
        request:           '',
        message:           '',
        data:              null,
        isVideo:           false,
        redirectUrl:       null,
        title:             '',
      },

    };
  },
  computed: {
    modalKind() {
      const request = this.modelData.request;
      const message = this.modelData.message || '';
      if (request === 'VideoEnableWarning' || request === 'VideoDisableError') return 'warning';
      if (message.includes('Success')) return 'success';
      if (request === 'SaveReq') return 'info';
      if (request === 'SaveOrderReject' || request === 'LoadingProductErrorMessage') return 'error';
      return 'confirm';
    },
    isBanner() {
      return this.modalKind === 'warning';
    },
    modalIcon() {
      if (this.modalKind === 'success') return 'check-circle';
      if (this.modalKind === 'error') return 'error-circle';
      if (this.modalKind === 'info') return 'help-circle';
      if (this.modalKind === 'warning') return 'alert-triangle';
      return 'trash';
    },
    modalButtons() {
      const ok = { label: 'Ok', background: '#1570EF', color: '#ffffff', variant: 'solid' };
      const okOutline = { label: 'Ok', background: '#ffffff', color: '#14161B', variant: 'outline' };
      if (this.modelData.request === 'VideoEnableWarning') {
        return [
          { label: 'Cancel', background: '#ffffff', color: '#14161B', variant: 'outline' },
          { label: 'Continue', background: '#1570EF', color: '#ffffff', variant: 'solid' },
        ];
      }
      if (this.modalKind === 'error') return [okOutline];
      if (this.modalKind === 'success' || this.modalKind === 'info' || this.modelData.request === 'VideoDisableError') return [ok];
      return [
        { label: 'No', background: '#ffffff', color: '#14161B', variant: 'outline' },
        { label: 'Yes', background: '#D92D20', color: '#ffffff', variant: 'solid' },
      ];
    },
  },
  mounted() {
    EventBus.$on(ApplicationEventTypes.ModalEvents.TOGGLE_CONFIRMATION_MODAL, this.updateCofirmationModal);
  },


  methods: {
    handleModalClose() {
      this.$store.commit('setImageModel', false);
      this.modelData.isImageModalShown = false;
    },
    handleOkClick() {
      const redirectUrl = this.modelData.redirectUrl;
      this.handleModalClose();
      if (redirectUrl) {
        window.top.location = redirectUrl;
      }
    },

    updateCofirmationModal(temData) {
      this.modelData.isImageModalShown = true;
      this.modelData.redirectUrl = null;
      this.modelData.title = temData.title || '';
      if (temData.request == 'DeleteReq') {
        this.modelData.request =  temData.request;
        this.modelData.message = temData.message;
        this.modelData.data    = temData.data;
        this.modelData.isVideo = temData.isVideo ? temData.isVideo : false;
      } else if (temData.request == 'SaveReq') {
        this.modelData.request =  temData.request;
        this.modelData.message = temData.message;
        this.modelData.data    = temData.data || null;
      } else if (temData.request === 'SaveReqWithRedirect') {
        this.modelData.request    = temData.request;
        this.modelData.message    = temData.message;
        this.modelData.data       = temData.data || null;
        this.modelData.redirectUrl = temData.data && temData.data.location ? temData.data.location : null;
      } else if (temData.request == 'DeletePageRequest') {
        this.modelData.request = temData.request;
        this.modelData.message = temData.message;
        this.modelData.data    = temData.data;
      } else if (temData.request == 'SaveOrderReject') {
        this.modelData.request = temData.request;
        this.modelData.message = temData.message;
      } else if (temData.request == 'SaveOrderReject') {
        this.modelData.request = temData.request;
        this.modelData.message = temData.message;
      } else if (temData.request == 'LoadingProductErrorMessage') {
        this.modelData.request = temData.request;
        this.modelData.message = temData.message;
      } else if (temData.request === 'deleteFavouriteSizeFromAPI') {
        this.modelData.request = temData.request;
        this.modelData.message = temData.message;
        this.modelData.data    = temData.data;
      } else if (temData.request === 'RemoveAudioFromProduct') {
        this.modelData.request = temData.request;
        this.modelData.message = temData.message;
      } else if (temData.request === 'VideoEnableWarning' || temData.request === 'VideoDisableError') {
        this.modelData.request = temData.request;
        this.modelData.message = temData.message;
        this.modelData.title = temData.title;
      }
    },
    onBackdrop() {
      if (this.isBanner) return;
      this.handleModalClose();
    },
    onButton(button) {
      if (button.label === 'Yes') this.deleteContent();
      else if (button.label === 'Continue') this.confirmVideoEnable();
      else if (button.label === 'Cancel') this.cancelVideoEnable();
      else if (button.label === 'Ok') this.confirmOk();
      else this.handleModalClose();
    },
    confirmVideoEnable() {
      EventBus.$emit(ApplicationEventTypes.ProductPageEvents.PRODUCT_PAGES_SHOULD_BE_SAME);
      this.handleModalClose();
    },
    cancelVideoEnable() {
      EventBus.$emit('resetToggleButton', false);
      this.handleModalClose();
    },
    confirmOk() {
      if (this.modelData.request === 'VideoDisableError') {
        this.$store.commit('activeProduct/updateIsVideoMoodOn', true);
      }
      this.handleOkClick();
    },
    deleteContent() {
      if (this.modelData.request == 'DeleteReq') { EventBus.$emit('deleteContentReq', this.modelData.data); } else if (this.modelData.request == 'DeletePageRequest') {
        EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.CLEARED);
        EventBus.$emit(ApplicationEventTypes.ProductPageEvents.PAGE_DELETE);
      } else if (this.modelData.request === 'deleteFavouriteSizeFromAPI') {
        EventBus.$emit('deleteFavouriteSize', this.modelData.data.id);
      } else if (this.modelData.request === 'RemoveAudioFromProduct') {
        EventBus.$emit(ApplicationEventTypes.Audio.ADD_NEW_AUDIO, null);
        EventBus.$emit('unSelectAudioLayer');
        this.$store.commit('activeProduct/UpdateIsAudioTrimOn', false);
        EventBus.$emit('toggleAudioLeftSectionAccordion', false);
      }

      this.modelData.isImageModalShown = false;
    },
  },
};

</script>
<style lang="scss">
.generic-modal{
  .bm-modal-content{
    max-height: none !important;
    height: auto;
    width: 30vw !important;
    min-width: 0;

    .bm-modal-footer{
      max-width: 250px;
    }
  }
  .close-icon-wrapper{
    top: 10px;
    right: 10px;
  }
}

@media screen and (max-width: 1285px){
  .bm-modal-content  .fs-20{
    font-size: 18px !important;
  }

}
</style>
<style scoped lang="scss">
.cm-root {
  position: fixed;
  inset: 0;
  z-index: 4000;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Geist', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif;
  color: #14161B;
}

.cm-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(237, 237, 237, 0.6);
}

.cm-dialog {
  position: relative;
  z-index: 1;
  width: 420px;
  max-width: calc(100vw - 32px);
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 0 0 1px rgba(16, 24, 40, 0.06), 0 24px 64px rgba(16, 24, 40, 0.28);
}

.cm-dialog.is-wide {
  width: 520px;
  overflow: hidden;
}

.cm-banner {
  display: flex;
  gap: 16px;
  padding: 24px 24px 20px;
}

.cm-copy h2 {
  margin: 0;
  font-family: inherit;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
  color: #14161B;
}

.cm-copy p {
  margin: 0 !important;
  padding-top: 8px;
  font-size: 13.5px;
  font-weight: 400;
  line-height: 1.55;
  color: #3D4350;
}

.cm-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 14px 24px;
  border-top: 1px solid #E7E9ED;
  background: #FBFBFC;
}

.cm-body {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 28px 28px 24px;
  text-align: center;
}

.cm-close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 8px;
  padding: 0;
  cursor: pointer;
  background: transparent;
  color: #3D4350;
}

.cm-close:hover {
  background: #F3F4F6;
}

.cm-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: #FEF3F2;
  color: #D92D20;
}

.cm-icon.is-success {
  background: #ECFDF3;
  color: #127A43;
}

.cm-icon.is-info {
  background: #EAF2FE;
  color: #0B57C2;
}

.cm-icon.is-warning {
  width: 44px;
  height: 44px;
  background: #FFFAEB;
  color: #B54708;
}

.cm-text {
  margin: 0 !important;
  font-size: 17px;
  font-weight: 600;
  line-height: 1.45;
  color: #14161B;
}

.cm-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
  width: 100%;
  margin-top: 8px;
}

.cm-actions.is-single .cm-btn,
.cm-footer .cm-btn {
  flex: 0 0 auto;
}

.cm-btn {
  flex: 1 1 0;
  height: 38px;
  min-width: 72px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 14px;
  border: 0;
  border-radius: 9px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
}

.cm-btn.is-outline {
  box-shadow: inset 0 0 0 1px #D5D9E0;
}

.cm-btn.is-solid {
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.12);
}

.cm-btn:focus,
.cm-close:focus {
  outline: none;
  border: 0;
}

.cm-close ::v-deep .icon,
.cm-icon ::v-deep .icon {
  min-width: 0;
  min-height: 0;
}

.cm-close ::v-deep svg {
  width: 16px;
  height: 16px;
}

.cm-icon ::v-deep svg {
  width: 24px;
  height: 24px;
}

.cm-icon.is-warning ::v-deep svg {
  width: 22px;
  height: 22px;
}
</style>
